import { schema } from 'normalizr';

export const billingSchema = new schema.Entity(
  'billing',
  {},
  { idAttribute: value => value.customer.metadata.groupId }
);
